<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesPrdProjectPlanPrpResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName" edit-disable
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <em-button type="edit" custom-icon="fa fa-fw fa-lg fa-list-alt"
                                               custom-label="KAM行编辑"
                                               :showName="true"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="gotoKamSelection()">
                                    </em-button>
                                    <em-button type="edit" custom-icon="fa fa-solid fa-pen-to-square"
                                               :disabled="$_notCheckedOne"
                                               custom-label="KAM Change"
                                               :showName="true"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="gotoKamSelection(true)">
                                    </em-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>


        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>

    </div>
</template>
<script>
// Author YuJiaBei
// Date 2021-05-23 09:53:55

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonApiMixin from "@/mixin/em/common/api";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";

export default {
    name: "sithMesPrdProjectPlanPrpDmpManageView",
    mixins: [emCommonListMixin, emCommonGotoMixin, emCommonApiMixin, emTableCheckedMixin],
    components: {},
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    data() {
        return {
            onNotifyEng: false,
            onUnpdateKam: false,
        }
    },
    computed: {
        modelName() {
            return 'sithMesPrdProjectPlanPrp'
        },
    },
    mounted() {
        if (this.$route.query.hasOwnProperty('id')) {
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('idFilter', this.$route.query.id);
            this.$refs.emListFilter.doQuery();
        }
    },
    methods: {
        gotoKamSelection(isKamChange = false) {
            if (this.$_notCheckedOne) {
                console.log('----here');
                this.$router.push('/sithMes/prd/sithMesPrdProjectKamSelection?currentUserRole=EN');
            } else {
                let projectCode = this.checkedRows[0].projectCode;
                let projectName = this.checkedRows[0].projectName;
                this.$router.push("/sithMes/prd/sithMesPrdProjectKamSelection?projectCode=" + projectCode + "&projectName=" + projectName + '&isKamChange=' + isKamChange);
            }
        }
    }
};
</script>

<style scoped>
</style>